import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, ChevronsRight } from "lucide-react";
import {
  Pagination as UIPagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";
import { ApiDataProps } from "@/pages/Tenants";
import { TypePageActions } from "@/pages/Plans";

/**
 * Propriedades do componente de paginação
 */
type PaginationProps = {
  current_page: number;
  last_page: number;
  handleNext: () => void;
  handlePrevious: () => void;
  handleLastPage: () => void;
};

/**
 * Componente de paginação para tabelas
 * 
 * @param {PaginationProps} props - Propriedades do componente 
 * @returns {JSX.Element} Componente renderizado
 */
export const Pagination = ({
  current_page,
  last_page,
  handleNext,
  handlePrevious,
  handleLastPage,
}: PaginationProps) => {
  return (
    <div className="flex justify-end my-4 gap-2">
      <div className="flex items-center text-sm">
        Página {current_page} de {last_page}
      </div>
      <Button
        variant="outline"
        size="icon"
        onClick={handlePrevious}
        disabled={current_page <= 1}
        className="h-8 w-8"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={handleNext}
        disabled={current_page >= last_page}
        className="h-8 w-8"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={handleLastPage}
        disabled={current_page >= last_page}
        className="h-8 w-8"
      >
        <ChevronsRight className="h-4 w-4" />
      </Button>
    </div>
  );
};

// Alternative pagination component with dataApi and pageActions
type ComponentControlsPaginationProps = {
  dataApi: ApiDataProps<any>;
  pageActions: TypePageActions;
};

export const ComponentControlsPagination = ({ 
  dataApi, 
  pageActions 
}: ComponentControlsPaginationProps) => {
  return (
    <div className="flex justify-between mb-3">
      {dataApi?.data?.length > 0 && (
        <span className="font-medium">
          Exibindo {dataApi?.current_page} de um total de {dataApi.last_page}
        </span>
      )}
      {dataApi?.last_page > 1 && (
        <UIPagination className="">
          <PaginationContent>
            <PaginationItem>
              <PaginationPrevious
                href="#"
                className="text-black h-8 hover:bg-stone-950/5"
                onClick={pageActions.previous}
              />
            </PaginationItem>
            <PaginationItem>
              <PaginationLink
                href="#"
                className="rounded-full mx-1 size-8 bg-transparent border border-zinc-300 shadow-sm text-slate-900 font-bold pointer-events-none"
              >
                <span className="dark:text-[#F4F4F5]">
                  {dataApi.current_page}
                </span>
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationNext
                href="#"
                className="text-black h-8 hover:bg-stone-950/5"
                onClick={pageActions.next}
              />
            </PaginationItem>
          </PaginationContent>
        </UIPagination>
      )}
    </div>
  );
}; 